export default "__VITE_ASSET__Cdckbdab__"